import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { SarvaLogo } from "./SarvaMark";

export default function Footer() {
  const nav = [
    { to: "/services", label: "Services" },
    { to: "/solutions", label: "Solutions" },
    { to: "/insights", label: "Insights" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];
  const legal = [
    { to: "/legal/privacy", label: "Privacy" },
    { to: "/legal/disclaimer", label: "Disclaimer" },
    { to: "/legal/terms", label: "Terms of Use" },
    { to: "/legal/cookies", label: "Cookie Policy" },
  ];
  return (
    <footer className="bg-ink border-t rule-dark" data-testid="footer">
      <div className="wrap pt-16 pb-44 lg:pb-20">
        <img src="/brand/lockup-white.png" alt="SarvaRitam™ — The Essence Of All That Is Right & Natural" className="h-28 w-auto" data-testid="footer-logo" draggable="false" />
        <p className="text-mute text-[14px] mt-6">ESG &amp; Sustainability Advisory</p>
        <p className="text-white/88 text-[13px] mt-2 max-w-sm leading-relaxed">
          Turning sustainability into measurable business value.
        </p>

        <div className="mt-12 pt-10 border-t rule-dark flex flex-col md:flex-row md:items-center justify-between gap-8">
          <nav className="flex flex-wrap gap-x-7 gap-y-3" aria-label="Footer" data-testid="footer-nav">
            {nav.map((l) => (
              <Link key={l.to} to={l.to} className="u-sweep py-1.5 text-[13px] font-semibold text-mute hover:text-white transition-colors" data-testid={`footer-${l.label.toLowerCase()}`}>
                {l.label}
              </Link>
            ))}
            {legal.map((l) => (
              <Link key={l.to} to={l.to} className="py-1.5 text-[13px] text-white/68 hover:text-gold transition-colors" data-testid={`footer-${l.to}`}>
                {l.label}
              </Link>
            ))}
            <a
              href="https://www.linkedin.com/company/sarvaritam/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="SarvaRitam on LinkedIn"
              className="inline-flex items-center gap-2 text-[13px] font-semibold text-mute hover:text-gold transition-colors"
              data-testid="footer-linkedin-link"
            >
              <Linkedin size={14} className="text-gold" /> LinkedIn
            </a>
          </nav>
          <div className="text-[12px] text-white/78 space-y-1.5 md:text-right">
            <p><a href="mailto:sarvaritam@gmail.com" className="hover:text-gold transition-colors" data-testid="footer-email-link">sarvaritam@gmail.com</a> · <a href="tel:+919228411223" className="hover:text-gold transition-colors" data-testid="footer-phone-link">+91 92284 11223</a></p>
            <p data-testid="footer-location">Lower Parel, Mumbai, Maharashtra 400013, India</p>
          </div>
        </div>

        <div className="mt-10 pt-7 border-t rule-dark flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-[12px] text-white/62" data-testid="footer-copyright">© 2026 SarvaRitam™. All rights reserved.</p>
          <p className="text-[10px] font-mono tracking-wide text-white/45 sm:text-right" data-testid="footer-statutory">
            PAN: AFRFS3675M · GSTIN: 27AFRFS3675M1ZZ · UDYAM: UDYAM-MH-19-0371501 · FSSAI Lic.: 11525997000839
          </p>
        </div>
      </div>
    </footer>
  );
}
